export default __webpack_public_path__ + "static/media/lp-new-ganzkoerper-exercise-00.d1fed42e.jpg";